interface SegmentedOption {
  value: string
  label: string
}

interface SegmentedProps {
  options: SegmentedOption[]
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export const Segmented = ({ options, value, onChange, disabled }: SegmentedProps) => (
  <div className="flex flex-wrap gap-2">
    {options.map((opt) => {
      const selected = value === opt.value
      return (
        <button
          key={opt.value}
          type="button"
          disabled={disabled}
          onClick={() => onChange(opt.value)}
          className={`flex-1 min-w-[88px] rounded-[12px] border-2 px-4 py-3 text-sm font-semibold transition-colors ${
            selected
              ? "border-figmaPrimary bg-figmaPrimary text-white"
              : "border-figmaLightGray bg-figmaLightGray text-figmaBlack hover:border-figmaPrimary/40"
          } ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
        >
          {opt.label}
        </button>
      )
    })}
  </div>
)
